import { format } from "date-fns";
import { Calendar } from "primereact/calendar";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { fetchData } from "../../../Services/GlobalService";
import { downloadExcel } from "../../../Services/GlobalFunction/DownLoadExcel";
import { GetDateFormat } from "../../../Services/GlobalFunction/GetDateFormat";
import * as Fa from "react-icons/fa";

const DBSipRawData = () => {
  const [fromdate, setFromdate] = useState<Date>(new Date());
  const [toDate, setToDate] = useState<Date>(new Date());
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);

  const getformat = GetDateFormat();
  const userId = localStorage.getItem("UserId")?.toString();

  const BaseUrl = "DBSIPRawData/DBSIPRawData";
  const Endpoint = {
    GetRawData: "DbSIPRawData",
  };

  /* ── Download Excel ── */
  const ExcelDownloadData = async () => {
    setLoadingExcel(true);
    try {
      const startDate = format(fromdate, "yyyyMMdd");
      const endDate = format(toDate, "yyyyMMdd");

       const response = await fetchData(
        BaseUrl,
        Endpoint.GetRawData,
        `StartDate=${Number(startDate)}&EndDate=${Number(endDate)}`,
      );

      if (response?.Data?.FileURl) {
        const link = document.createElement("a");
        link.href = response.Data.FileURl;
        link.download = `DB_SIP_Raw_Data_${getformat}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        toast.error("Failed to download file");
      }
    } catch (ex: any) {
      toast.error(ex?.response?.data?.Message ?? "Failed to download file");
    } finally {
      setLoadingExcel(false);
    }
  };

  return (
    <>
      <main>
        <div className="col-12 mb-5">
          <div className="row">
            {/* Breadcrumb */}
            <div className="col-lg-12 col-md-12 col-sm-12">
              <nav aria-label="breadcrumb" className="drop-in">
                <ol className="breadcrumb mx-0">
                  <li className="breadcrumb-item">DB SIP</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    DB SIP Raw Data
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <h3 className="py-2">DB SIP Raw Data</h3>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12"></div>
          </div>

          <section className="sales-box">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-5 col-md-12 col-sm-12">
                <form>
                  {/* From Date */}
                  <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                    <div className="d-block">
                      <label className="form-label">From Date</label>
                      <Calendar
                        value={fromdate}
                        onChange={(e) => setFromdate(e.value as Date)}
                        showIcon
                        dateFormat="dd/mm/yy"
                        maxDate={toDate}
                      />
                    </div>
                  </div>

                  {/* To Date */}
                  <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                    <div className="d-block">
                      <label className="form-label">To Date</label>
                      <Calendar
                        value={toDate}
                        onChange={(e) => setToDate(e.value as Date)}
                        showIcon
                        dateFormat="dd/mm/yy"
                        minDate={fromdate}
                        maxDate={new Date()}
                      />
                    </div>
                  </div>

                  {/* Save As Excel */}
                  <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="text-end mt-3">
                      <button
                        type="button"
                        className="btn anime-btn"
                        onClick={ExcelDownloadData}
                        disabled={loadingExcel}
                      >
                        {loadingExcel ? (
                          <>
                            Loading...{" "}
                            <span
                              className="spinner-border spinner-border-sm ms-1"
                              role="status"
                              aria-hidden="true"
                            />
                          </>
                        ) : (
                          <>
                            Save As Excel <Fa.FaDownload className="ms-2" />
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div className="col-lg-7 col-md-12 col-sm-12">
                <div className="text-end">
                  <img
                    src={require("../../../Assets/Images/data_report.png")}
                    className="Side_Img drop-right"
                    alt="DB SIP Raw Data"
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default DBSipRawData;